import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceMetrics = ({ stats, followerCount }) => {
  const metrics = [
    {
      label: 'Total Assignments',
      value: stats?.totalAssignments,
      icon: 'Briefcase',
      color: 'bg-primary',
      subtext: `${stats?.completedAssignments} completed`
    },
    {
      label: 'Completion Rate',
      value: `${stats?.completionRate}%`,
      icon: 'TrendingUp',
      color: 'bg-success',
      subtext: `${stats?.inProgressAssignments} in progress`
    },
    {
      label: 'Lines Recorded',
      value: stats?.completedLines,
      icon: 'Mic',
      color: 'bg-accent',
      subtext: `of ${stats?.totalLines} total lines`
    },
    {
      label: 'Followers',
      value: followerCount || 0,
      icon: 'Users',
      color: 'bg-secondary',
      subtext: 'students following you'
    },
    {
      label: 'Recording Sessions',
      value: stats?.completedSessions,
      icon: 'Calendar',
      color: 'bg-warning',
      subtext: `${stats?.upcomingSessions} upcoming`
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
      {metrics?.map((metric, index) => (
        <div 
          key={index}
          className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-all duration-200"
        >
          <div className="flex items-start justify-between mb-4">
            <div className="flex-1">
              <p className="text-sm font-medium text-muted-foreground mb-1">
                {metric?.label}
              </p>
              <h3 className="text-3xl font-bold text-card-foreground">
                {metric?.value}
              </h3>
            </div>
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${metric?.color}`}>
              <Icon name={metric?.icon} size={24} color="white" />
            </div>
          </div>
          <p className="text-sm text-muted-foreground">
            {metric?.subtext}
          </p>
        </div>
      ))}
    </div>
  );
};

export default PerformanceMetrics;